import React from "react";
import "./Map.css";

function Map() {
  const handleDirections = () => {
    window.open(
      "https://www.google.com/maps/dir/?api=1&destination=41+Cuff+Rd,+Singapore+209751",
      "_blank"
    );
  };

  return (
    <section id="map" className="map-section">
      <h2 className="map-title">Our Location</h2>

      <div className="map-card">
        {/* LEFT SIDE */}
        <div className="map-info">

          <p>41 Cuff Rd, Singapore 209751</p>

          <button className="directions-btn" onClick={handleDirections}>
            GET DIRECTIONS
          </button>

          <div className="timings-box">
            <h4>Business Hours</h4>
            <p>Mon – Sun: 8:00 AM – 10:30 PM</p>
            <p>Closed on Public Holidays</p>
          </div>
        </div>

        {/* RIGHT SIDE MAP */}
        <div className="map-embed-wrapper">
          <div className="map-mask">
            <iframe
              title="TKS Courier Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7802437902124!2d103.85086607348973!3d1.307028861715068!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8a0038a90622082d%3A0x2eabdaceb48cb96e!2sTKS%20COURIER%20%26CARGO%20INTERNATIONAL%20SERVICE!5e0!3m2!1sen!2sin!4v1763395612435!5m2!1sen!2sin"
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Map;
